import SubjectHeader from '../../components/SubjectHeader/SubjectHeader';
import NoLiveSessions from '../../components/NoLiveSessions/NoLiveSessions';
import { useEffect, useState, SyntheticEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLazyQuery, useMutation } from "@apollo/client";
import ToasterWithMessage from '../../components/toaster';
import CustomTab from '../CustomTab/CustomTab';
import { useAppSelector } from '../../redux/app/hooks';
import ConfirmationPopup from '../../components/ConfirmationPopup/ConfirmationPopup';
import images from "../../assets/images";
import './Assignments.scss';
import Loader from '../../components/Loader/Loader';
import { 
  STUDENT_ROLE, 
  TEACHER_ROLE, 
  theme, 
  FETCH_POLICY, 
  FETCH_POLICY_NO_CACHE, 
  SUBJECT_NOT_FOUND_ERROR, 
  SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, 
  PATH_ADDRESSES, 
  EXPIRY_MINUTES_VALIDATION_MESSAGE, 
  SUBMITTED_ASSIGNMENTS_TEXT 
} from '../../utils/constants';
import FileUpload from '../../components/Popups/FileUpload';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import { 
  DELETE_ASSIGNMENT, 
  DELETE_SUBMITTED_ASSIGNMENTS, 
  GET_ALL_SUBMITTED_ASSIGNMENTS, 
  GET_ASSIGNMENT_EXPIRY_TIME, 
  GET_ASSIGNMENTS, 
  SET_ASSIGNMENT_EXPIRY_TIME, 
  STUDENTS_LIST_FOR_ASSIGNMENTS, 
  SUBMIT_ASSIGNMENT, 
  UPDATE_ASSIGNMENT, 
  UPDATE_SUBMITTED_ASSIGNMENTS, 
  UPLOAD_ASSIGNMENT 
} from './api/AssignmentsQuery';
import AssignmentCard from './Components/AssignmentCard';
import PDFViewer from '../../components/PDFViewer/PDFViewer';
import CsvViewer from '../../components/CsvViewer/CsvViewer';
import FileViewer from '../../components/FileViewer/FileViewer';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { CONVERT_PPT_DOCS_TO_PDF } from '../TeacherTeachingMaterial/api/TeacherTeachingMaterialQuery';
import { checkFileStatusInDatabase } from '../../database';
import { getFileViewerType, getScreenDimensions } from '../../utils/helper';
import ButtonStyle from '../../components/ButtonStyle/ButtonStyle';
import { ThemeProvider } from 'styled-components';
import { Dialog } from '@mui/material';
import { useForm } from 'react-hook-form';

export type Students = {
  studentAvatarUrl: string;
  studentId: string;
  studentName: string;
  totalScore: number;
}

export type assignment = {
  fileId: string;
  filename: string;
  filepath: string;
  filesize: number;
  filetype: string;
  isClassroom: boolean
  coverimagepath?: string;
  authorname?: string;
  feedId? : string
  isExpiry?: string;
}

export type assignmentData = {
  datas: assignment[],
  totalCount: number
}

export type students = {
  studentId: string,
  studentName: string,
  studentAvatarUrl:string
}

export type studentsData = {
  nodes: students[],
  totalCount: number
}

const Assignments = () => {
  const { state:locationState } = useLocation();
  const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [uploaded, setuploaded] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadFailed, setUploadFailed] = useState<boolean>(false);
  const [uploadFileName, setUploadFileName] = useState<string>('');
  const [url, setUrl] = useState<string>();
  const [filename, setFilename] = useState<string>();
  const [fileData, setFileData] = useState<File | null>();
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;
  const [assignmentsData, setAssignmentsData] = useState<assignmentData>();
  const [submittedAssignmentsData, setSubmittedAssignmentsData] = useState<assignmentData>();
  const [studentsData, setStudentsData] = useState<studentsData>();
  const [activeTab, setActiveTab] = useState<number>(0);
  const [selectedAssignment, setSelectedAssignment] = useState<assignment>();
  const [selectedStudent, setSelectedStudent] = useState<students>();
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [openShareConfirmationPopup, setOpenShareConfirmationPopup] = useState<boolean>(false);
  const [action, setAction] = useState<string>('');
  const [refetch, setRefetch] = useState<boolean>(false);
  const [downloadRefetch, setDownloadRefetch] = useState<boolean>(false);
  const { success, error } = ToasterWithMessage();
  const { ShareGif, DeleteGif, docsImg, uploadCloud, assignmentUser, closeIcon } = images;
  const role = useAppSelector((state) => state.auth.role);
  const labels = ["Assignment", role === TEACHER_ROLE ? "Submitted Assignment":"Submit Assignment"];
  const navigate = useNavigate();
  const backNavigation = (role === STUDENT_ROLE) ? PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH;
  const [subCategory, setSubCategory] = useState<string>();
  const [openPdf, setOpenPdf] = useState(false);
  const [openStudentAssignments, setOpenStudentAssignments] = useState(false);
  const profile = useAppSelector((state) => state.auth.adminProfile);
  const [fileExists, setFileExists] = useState<{ [key: string]: boolean| undefined }>({});
  const [openSetExpiry, setOpenSetExpiry] = useState(false);
  const { register, control, handleSubmit, trigger, reset, watch, setValue, getValues, formState : {errors} } = useForm<{ expiryTimeHours: number, expiryTimeMinutes: number }>({
    defaultValues: { expiryTimeHours: 0, expiryTimeMinutes: 0 }
  });

  // register configurations so we can reuse their event handlers when we need to wrap onBlur
  const expiryHoursRegister = register('expiryTimeHours', {
    valueAsNumber: true,
    min: { value: 0, message: 'Hours cannot be negative' },
    validate: (value) => {
      const hrs = Number(value ?? 0);
      const mins = Number(getValues('expiryTimeMinutes') ?? 0);
      return (hrs > 0 || mins > 0) || ('Please enter hours');
    }
  });

  const expiryMinutesRegister = register('expiryTimeMinutes', {
    valueAsNumber: true,
    min: { value: 0, message: EXPIRY_MINUTES_VALIDATION_MESSAGE },
    max: { value: 59, message: EXPIRY_MINUTES_VALIDATION_MESSAGE },
    validate: (value) => {
      const mins = Number(value ?? 0);
      const hrs = Number(getValues('expiryTimeHours') ?? 0);
      if (mins < 0 || mins > 59) {
        return (EXPIRY_MINUTES_VALIDATION_MESSAGE);
      }
      return (hrs > 0 || mins > 0) || ('Please enter minutes');
    }
  });
  
  const [getAllAssigments, { loading }] = useLazyQuery(GET_ASSIGNMENTS, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setAssignmentsData(data?.getAllUploadedAssignments);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  });

  const [getAllStudents, { loading: studentsLoading }] = useLazyQuery(STUDENTS_LIST_FOR_ASSIGNMENTS, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setStudentsData(data?.getSubmittedAssignmentsWithStudentDetails);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  });

  const [uploadAssignment] = useMutation(UPLOAD_ASSIGNMENT, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      if (data?.addAssignment) {
        setFileData(null);
        if (filename) {
          setUploadFileName(filename);
        }
        setuploaded(true);
        setUploadProgress(100);
        setFilename('');
        setUrl('');
        getAllAssigments({
          variables: {
            input: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              searchInput: `%%`,
              limit: null,
              offset: null
            }
          }
        })
      }
    },
    onError: (err) => {
      if (filename) {
        setUploadFileName(filename);
      }
      setuploaded(true);
      setUploadProgress(0);
      setUploadFailed(true);
    }
  });

  const [submitAssignment] = useMutation(SUBMIT_ASSIGNMENT, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      if (data?.submitAssignment) {
        setFileData(null);
        if (filename) {
          setUploadFileName(filename);
        }
        setuploaded(true);
        setUploadProgress(100);
        setFilename('');
        setUrl('');
        getSubmittedAssignments({
          variables: {
            input: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              searchInput: `%%`,
              limit: null,
              offset: null
            }
          }
        })
        console.log("submitted assignment data",data);
        console.log("submitted assignment parsing", data?.submitAssignment && JSON.parse(data?.submitAssignment));
        const submittedParsedData = data?.submitAssignment && JSON.parse(data?.submitAssignment);
        const submittedAssignmentFileData: assignment = {
          fileId: submittedParsedData?.file_id,
          filename: submittedParsedData?.filename,
          filepath: submittedParsedData?.filepath,
          filesize: submittedParsedData?.filesize,
          filetype: submittedParsedData?.filetype,
          isClassroom: submittedParsedData?.isClassroom,
        }
        setAction("share");
        setSelectedAssignment(submittedAssignmentFileData);
        setOpenShareConfirmationPopup(true);
      }
    },
    onError: (err) => {
      if (filename) {
        setUploadFileName(filename);
      }
      setuploaded(true);
      setUploadProgress(0);
      setUploadFailed(true);
    }
  });

  const [getSubmittedAssignments, { loading: loadingResults }] = useLazyQuery(GET_ALL_SUBMITTED_ASSIGNMENTS, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setSubmittedAssignmentsData(data?.getSubmittedAssignments);
      setDownloadRefetch(false);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  });

  const [updateAssignment] = useMutation(UPDATE_ASSIGNMENT, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: () => {
      setRefetch(!refetch);
      success(`${action === "share" ? "Shared" : "Unshared"} successfully`);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  })

  const [deleteAssignment] = useMutation(DELETE_ASSIGNMENT, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: () => {
      setRefetch(!refetch);
      success("Deleted successfully");
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  })

  const [updateSubmittedAssignment] = useMutation(UPDATE_SUBMITTED_ASSIGNMENTS, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: () => {
      setRefetch(!refetch);
      success(`${action === "share" ? "Shared" : "Unshared"} successfully`);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  })

  const [deleteSubmittedAssignment] = useMutation(DELETE_SUBMITTED_ASSIGNMENTS, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: () => {
      setRefetch(!refetch);
      success("Deleted successfully");
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  });

  const [getAssignmentExpiryTime, { loading: expiryLoading }] = useLazyQuery(GET_ASSIGNMENT_EXPIRY_TIME, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      const hours = Number(data?.getAssignmentExpiryTime?.hours ?? 0);
      const minutes = Number(data?.getAssignmentExpiryTime?.minutes ?? 0);
      setValue('expiryTimeHours', hours, { shouldValidate: true, shouldDirty: false });
      setValue('expiryTimeMinutes', minutes, { shouldValidate: true, shouldDirty: false });
      setTimeout(() => {
        trigger(['expiryTimeHours', 'expiryTimeMinutes']);
      }, 0);
    },
    onError: (err) => {
      error(err?.message || 'Failed to load expiry time');
      setValue('expiryTimeHours', 0, { shouldValidate: true });
      setValue('expiryTimeMinutes', 0, { shouldValidate: true });
    }
  });

  const [setAssignmentExpiryTime, { loading: setExpiryLoading }] = useMutation(SET_ASSIGNMENT_EXPIRY_TIME, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (_data) => {
      success('Expiry updated successfully');
      setOpenSetExpiry(false);
      setRefetch(!refetch);
    },
    onError: (err) => {
      error(err?.message || 'Failed to set expiry time');
    }
  });

  useEffect(() => {
    if (openSetExpiry) {
      if (!selectedClassRoomId || !selectedSubjectId) {
        setValue('expiryTimeHours', 0, { shouldValidate: true });
        setValue('expiryTimeMinutes', 0, { shouldValidate: true });
        return;
      }
      reset({ expiryTimeHours: 0, expiryTimeMinutes: 0 });
      getAssignmentExpiryTime({
        variables: {
          cId: selectedClassRoomId,
          sjId: selectedSubjectId
        }
      });
    }
  }, [openSetExpiry, selectedClassRoomId, selectedSubjectId, getAssignmentExpiryTime, setValue]);

  const checkFileExists = async (fileId: string) => {
    if (window.cordova) {
        try {
            const response = await checkFileStatusInDatabase(
                fileId,
                profile?.getCurrentUser?.nodes[0]?.uId,
                'Assignments'
            );
  
            console.log('File existence response:', response);
            if (response && response.success) {
                console.log(response,'=======file existance response');
                return response.exists;
            }
  
            console.error('Failed to check file existence:', response);
            return false;
        } catch (err) {
            console.error('Error checking file existence:', err);
            return false;
        }
    } else {
        console.warn("Cordova is not available");
        return false;
    }
  };
  
  const checkFiles = async (assignments: assignment[]) => {
    const updatedFileExists: Record<string, boolean| undefined> = {}; // Define the type here
    if (assignments && assignments.length > 0) {
        for (const assignment of assignments) {
            const exists = await checkFileExists(assignment.fileId);
            console.log('Inside the exists of checkFiles', exists);
            updatedFileExists[assignment.fileId] = exists; // Use the value from exists
        }
        setFileExists((prevState) => ({ ...prevState, ...updatedFileExists }));
    }
  };

  useEffect(() => {
    if (assignmentsData?.datas?.length) {
      checkFiles(assignmentsData.datas);
    }
  }, [assignmentsData]);
  
  useEffect(() => {
    if (submittedAssignmentsData?.datas?.length) {
      checkFiles(submittedAssignmentsData.datas);
    }
  }, [submittedAssignmentsData]);

  // Function to check if the file exists
const checkFileExistence = async (fileId: string): Promise<boolean|undefined> => {
  try {
      if(window.electron && window.electron.isElectron()){
      const response = await window.electron.checkFileStatus(fileId, profile?.getCurrentUser?.nodes[0]?.uId, 'Assignments');
      return response?.exists || false;
      }else{
        console.warn('Platform not supported');
      }
  } catch (error) {
      console.error('Error checking file existence:', error);
      return false;
  }
};

// Function to check all assignments' file status
const checkAllAssignmentsFileStatus = async (assignments: assignment[]) => {
  const updatedFileExists: Record<string, boolean| undefined> = {};
  for (const assignment of assignments) {
      const exists = await checkFileExistence(assignment.fileId);
      updatedFileExists[assignment.fileId] = exists;
  }
  // setFileExists(updatedFileExists);
  setFileExists((prevState) => ({ ...prevState, ...updatedFileExists })); // Use function form for setState

};

useEffect(() => {
  if (assignmentsData?.datas?.length) {
      checkAllAssignmentsFileStatus(assignmentsData.datas);
  }
}, [assignmentsData]);

useEffect(() => {
  if (submittedAssignmentsData?.datas?.length) {
      checkAllAssignmentsFileStatus(submittedAssignmentsData.datas);
  }
}, [submittedAssignmentsData]);


  const handleAssignmentActions = (selectedAssignment: assignment, action: string) => {
    if (selectedAssignment) {
      if (action === "delete") {
        if (role === TEACHER_ROLE) {
          deleteAssignment({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              fId: selectedAssignment?.fileId,
            }
          });
        } else if (role === STUDENT_ROLE) {
          deleteSubmittedAssignment({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              fId: selectedAssignment?.fileId,
            }
          });
        }
      }
      else if (action === "share" || action === "unshare") {
        if (role === TEACHER_ROLE) {
          updateAssignment({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              fId: selectedAssignment?.fileId,
              isClassroom: !selectedAssignment?.isClassroom
            }
          });
        } else if (role === STUDENT_ROLE) {
          updateSubmittedAssignment({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              fId: selectedAssignment?.fileId,
              isClassroom: !selectedAssignment?.isClassroom
            }
          });
        }
      }
    }
  }

  const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    if (selectedAssignment) {
      handleAssignmentActions(selectedAssignment, action)
    }
  }

  const onNoButtonClick = () => {
    setOpenConfirmationPopup(false);
  }

  const onYesButtonClickShare = () => {
    setOpenShareConfirmationPopup(false);
    if (selectedAssignment) {
      handleAssignmentActions(selectedAssignment, "share")
    }
  }

  const onNoButtonClickShare = () => {
    setAction('');
    setOpenShareConfirmationPopup(false);
  }

  const handleChangeTab = (_e: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    setOpenPdf(false);
    setSubCategory('');
  };

  const handleClick = (action: string, assignment: any) => {
    setAction(action);
    if (action === "unshare") {
      handleAssignmentActions(assignment, action)
    }
    else {
      setOpenConfirmationPopup(true);
    }
    setSelectedAssignment(assignment);
  }

  const handleClickCard = (item: assignment) => {
    setSelectedAssignment(item);
    setOpenPdf(true);
  }
  const handleClickStudent = (item: students) => {
    setSubCategory(item?.studentName);
    setSelectedStudent(item);
    setOpenStudentAssignments(true);
  }

  useEffect(() => {
    setSubCategory('');
    setRefetch(!refetch);
  }, [locationState]);

  useEffect(() => {
    if ((openStudentAssignments === true || downloadRefetch === true)&& selectedStudent) {
      getSubmittedAssignments({
        variables: {
          input: {
            cId: selectedClassRoomId,
            sjId: selectedSubjectId,
            sId: selectedStudent?.studentId,
            searchInput: `%%`,
            limit: null,
            offset: null
          }
        }
      });
    }
  }, [downloadRefetch,openStudentAssignments]);
  
  
  useEffect(() => {
    // setAssignmentsData(undefined);
    // setStudentsData(undefined);
    setOpenStudentAssignments(false);
    if (selectedClassRoomId && selectedSubjectId) {
      if (activeTab === 0) {
        getAllAssigments({
          variables: {
            input: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              searchInput: `%%`,
              limit: null,
              offset: null
            }
          }
        });
      }
      else {
        if (role === STUDENT_ROLE) {
          getSubmittedAssignments({
            variables: {
              input: {
                cId: selectedClassRoomId,
                sjId: selectedSubjectId,
                // sId: selectedStudentId,
                searchInput: `%%`,
                limit: null,
                offset: null
              }
            }
          });
        } else if (role === TEACHER_ROLE) {
          getAllStudents({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              // searchInput: `%%`,
              limit: null,
              offset: null
            }
          });
        }
      }
    }
  }, [activeTab, refetch]);



  const [readAssignmentFeed] = useMutation(READ_CLASSROOMUPDATES, {
    fetchPolicy: FETCH_POLICY,
    onCompleted : (data) =>{
    },
    onError: (err) =>{
      console.log(err.message)
    }
  })

  const [convertPptDocToPdf, { loading: convertLoading }] = useLazyQuery(CONVERT_PPT_DOCS_TO_PDF, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
        console.log('CONVERT_PPT_DOCS_TO_PDF response========>',data);
    },
    onError: (err) => {
      error(err?.message);
      // setuploaded(true);
      // setUploadProgress(0);
      // setUploadFailed(true);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
});

  useEffect(()=>{
  if(role === STUDENT_ROLE){
  if(assignmentsData?.datas?.length && assignmentsData?.datas?.length > 0){
    assignmentsData?.datas.forEach((data) => {
      if (data.feedId) {
        readAssignmentFeed({
          variables: {
            fId: data.feedId,
            uId: profile?.getCurrentUser?.nodes[0]?.uId
          }
        })
      }
    });
  }
}
  },[assignmentsData, profile?.getCurrentUser?.nodes, readAssignmentFeed, role])

  useEffect(() => {
    if (fileData && filename && filename !== '' && url) {
        const parts = url.split('.');
        const extension = parts.length > 1 ? parts.pop() : undefined;
        const uploadVariablesForTeacher = {
            filename: filename?.replace(/\.pdf$/, "")?.trim(),
            filepath: url,
            filesize: fileData?.size,
            filetype: fileData?.type === "application/pdf" ? "pdf" : fileData?.type === "text/csv" ? "csv" : fileData?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? "xlsx" : fileData?.type === "application/vnd.ms-excel" ? "xls" : fileData?.type === "application/vnd.ms-powerpoint" ? "ppt" : fileData?.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation" ? "pptx" : fileData?.type === "application/msword" ? "doc" : fileData?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? "docx" : null,
            isClassRoom: false,
            sjId: selectedSubjectId,
            cId: selectedClassRoomId,
        }
        const uploadVariablesForStudent = {
          filename: filename?.replace(/\.pdf$/, "")?.trim(),
          filepath: url,
          filesize: fileData?.size,
          filetype: fileData?.type === "application/pdf" ? "pdf" : fileData?.type === "text/csv" ? "csv" : fileData?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? "xlsx" : fileData?.type === "application/vnd.ms-excel" ? "xls" : fileData?.type === "application/vnd.ms-powerpoint" ? "ppt" : fileData?.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation" ? "pptx" : fileData?.type === "application/msword" ? "doc" : fileData?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? "docx" : null,
          isClassroom: false,
          sjId: selectedSubjectId,
          cId: selectedClassRoomId,
          needFileInfo: true
        };

        if (extension && ['doc', 'docx', 'ppt', 'pptx'].includes(extension.toLowerCase())) {
            // Convert documents or PowerPoint files to PDF
            convertPptDocToPdf({
                variables: {
                    key: url
                }
            })
            .catch(error => {
                console.error("Error during conversion or upload:", error);
            });
            if (role === TEACHER_ROLE) {
                uploadAssignment({
                    variables: uploadVariablesForTeacher,
                });
            } else {
                submitAssignment({
                    variables: {
                        input: uploadVariablesForStudent,
                    }
                });
            }
        } else {
            // Directly upload if no conversion is needed
            if (role === TEACHER_ROLE) {
                uploadAssignment({
                    variables: uploadVariablesForTeacher,
                });
            } else {
                submitAssignment({
                    variables: {
                        input: uploadVariablesForStudent,
                    }
                });
            }
        }
    }
}, [fileData, filename, url, role, selectedSubjectId, selectedClassRoomId]);


  //To open upload popup
  const handleOpenUploadAssignment = () => {
    setIsUploadOpen(true);
    setOpen(true);
  };

  //To close pdf detailed view
  const handleClosePdf = () => {
    if(role === TEACHER_ROLE && openStudentAssignments && activeTab === 1 && !openPdf){
      setOpenPdf(false);
      setOpenStudentAssignments(false);
      setSubCategory('');
      setSelectedAssignment(undefined);
      setSelectedStudent(undefined);
      setRefetch(true);
    }else{
    setOpenPdf(false);
    setSelectedAssignment(undefined);
    setRefetch(true);
    }
  }

  const handleClickSetExpiry = () => {
    setOpenSetExpiry(true);
  }

  const onSubmitExpiry = (data: any) => {
    const hours = Number(data?.expiryTimeHours ?? 0);
    const minutes = Number(data?.expiryTimeMinutes ?? 0);

    if (!selectedClassRoomId || !selectedSubjectId) {
      error('Classroom or subject not selected');
      return;
    }

    setAssignmentExpiryTime({
      variables: {
        cId: selectedClassRoomId,
        expiryHours: Math.max(0, Math.floor(hours)),
        expiryMinutes: Math.max(0, Math.min(59, Math.floor(minutes))),
        sjId: selectedSubjectId
      }
    });
  }

  const handleCloseSetExpiry = () => {
    setOpenSetExpiry(false);
  }

  return (
    <div className='assignmentMainContainer'>
      <div className='assignmentHeader'>
        <SubjectHeader
          headerName={locationState?.title}
          backgroundColor={locationState?.backGroundColor}
          subCategory={subCategory}
          headerImage={locationState?.imageSrc}
          backNavigation={{ path: backNavigation, state: locationState }}
          tabName={activeTab === 1 ? SUBMITTED_ASSIGNMENTS_TEXT :'Assignments'}
          openPdf={openPdf}
          onClose={handleClosePdf}
          openStudentAssignments={openStudentAssignments}
        />
        <div className='assignmentTabContainer'>
          <CustomTab activeTab={activeTab} handleChangeTab={handleChangeTab} labels={labels} />
          <div className='expiryAndUploadContainer'>
            {(role === TEACHER_ROLE && 
                <ButtonStyle text="Set Expiry" width='95px' paddingLeft='30px' paddingRight='30px' onClick={handleClickSetExpiry}/>
            )}
          { !getScreenDimensions().isMobileScreen &&<div className={(((role === TEACHER_ROLE && activeTab === 0) || (role === STUDENT_ROLE && activeTab === 1 && assignmentsData && assignmentsData?.totalCount > 0)) && !openPdf) ? 'assignmentHeaderUpload' : 'uploadHide'} onClick={(((role === TEACHER_ROLE && activeTab === 0) || (role === STUDENT_ROLE && activeTab === 1 && assignmentsData && assignmentsData?.totalCount > 0)) && !openPdf) ? handleOpenUploadAssignment : undefined}>
              <img src={uploadCloud} alt="upload" className='uploadImage' />
            </div>}
        </div>
        </div>
      </div>
      {(loading || loadingResults || studentsLoading) ? (
        <Loader bottom="110px" />
      ) : (
        <>
          {openPdf ? ( selectedAssignment?.filetype === "pdf" ? 
            <div className='DetailedView'>  
              <PDFViewer
                file={selectedAssignment?.filepath ? baseUrl + selectedAssignment?.filepath : ''}
                pdfFileData={selectedAssignment}
                onClose={handleClosePdf}
                type="Assignment"
              />
            </div>
            // : selectedAssignment?.filetype === "csv" ? 
            //   <div className='excelOuterContainer'>
            //     <CsvViewer
            //       fileUrl={selectedAssignment?.filepath ? baseUrl + selectedAssignment?.filepath : ''}
            //       fileData={selectedAssignment}
            //       onClose={handleClosePdf}
            //     /> 
            //   </div>
            : (selectedAssignment?.filetype === "doc" || selectedAssignment?.filetype === "docx" || selectedAssignment?.filetype === "ppt" || selectedAssignment?.filetype === "pptx" || selectedAssignment?.filetype === "xls" || selectedAssignment?.filetype === "xlsx") ?
              <div className='excelOuterContainer'>
                <FileViewer fileUrl={selectedAssignment?.filepath ? baseUrl + selectedAssignment?.filepath : ''} fileData={selectedAssignment} onClose={handleClosePdf} fileType={getFileViewerType(selectedAssignment?.filetype)}/>
              </div>
            : (selectedAssignment?.filetype === "csv" ) ?
            <div className='excelOuterContainer'>
              <CsvViewer fileUrl={selectedAssignment?.filepath ? baseUrl + selectedAssignment?.filepath : ''} fileData={selectedAssignment} onClose={handleClosePdf} />
            </div>
            : <></>
            ) : (
            <>
              {/* {(assignmentsData?.totalCount === 0 || studentsData?.totalCount === 0 || submittedAssignmentsData?.totalCount === 0) && <NoLiveSessions tabName="Assignment" />} */}
              {activeTab === 0 ? (
                (assignmentsData && assignmentsData?.totalCount > 0 && !openPdf) ? (
                   <div className="assignmentCardContainer">
                    {assignmentsData?.datas.map((item) => (
                      <AssignmentCard
                        key={item?.fileId}
                        image={docsImg}
                        subject={locationState?.title}
                        subCategory={'Assignments'}
                        data={item}
                        fileExists={fileExists[item?.fileId]}
                        reload={()=>setRefetch(!refetch)}
                        tabName={'Assignment'}
                        handleClickShareDelete={handleClick}
                        handleClickCard={handleClickCard}
                      />
                    ))}
                  </div>
                )
                :(
                  <NoLiveSessions tabName="Assignment" />
                )
              ) : (
                (role === TEACHER_ROLE && !openStudentAssignments) ? (
                  (studentsData && studentsData?.totalCount > 0 && !openPdf ) ? (
                    <div className="studentCardContainer">
                      {studentsData?.nodes.map((item) => (
                        <div className='studentCard' key={item?.studentId} onClick={() => handleClickStudent(item)}>
                          <div className="studentImageCtn">
                            <img src={item?.studentAvatarUrl ? baseUrl + item?.studentAvatarUrl : assignmentUser} alt="studentImage" className="studentImg" />
                          </div>
                          <div className="studentName">{item?.studentName}</div>
                        </div>
                      ))}
                    </div>
                  ):(
                    <NoLiveSessions tabName="Assignment" />
                  )
                ) : (
                  (submittedAssignmentsData && submittedAssignmentsData?.totalCount > 0 && !openPdf ) ? (
                    <div className="assignmentCardContainer">
                      {submittedAssignmentsData?.datas.map((item) => (
                        <AssignmentCard
                          key={item?.fileId}
                          image={docsImg}
                          data={item}
                          subject={locationState?.title}
                          fileExists={fileExists[item?.fileId]}
                          reload={()=>setDownloadRefetch(true)}
                          tabName={SUBMITTED_ASSIGNMENTS_TEXT}
                          handleClickShareDelete={handleClick}
                          handleClickCard={handleClickCard}
                        />
                      ))}
                    </div>
                  ):(
                    <NoLiveSessions tabName="Assignment" />
                  )
                )
              )}
            </>
          )}
           { getScreenDimensions().isMobileScreen && <div className={(((role === TEACHER_ROLE && activeTab === 0) || (role === STUDENT_ROLE && activeTab === 1 && assignmentsData && assignmentsData?.totalCount > 0)) && !openPdf) ? `assignmentHeaderUpload ${getScreenDimensions().isMobileScreen?'mobileassignmentHeaderUpload':'' }` : 'uploadHide'} onClick={(((role === TEACHER_ROLE && activeTab === 0) || (role === STUDENT_ROLE && activeTab === 1 && assignmentsData && assignmentsData?.totalCount > 0)) && !openPdf) ? handleOpenUploadAssignment : undefined}>
           <div className='upload'> <img src={uploadCloud} alt="upload" className='uploadImage' /></div>
          </div>}
        </>
        
      )}
      
      {isUploadOpen && <FileUpload page="Assignments" type='assignment' name="Assignment" setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName} />}
      {uploaded && <UploadToaster uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />}
      <ConfirmationPopup
        open={openConfirmationPopup}
        message={action === "share" ? `Are you sure you want to Share this file with your Classroom?` : `Are you sure you want to Delete this file from the Classroom?`}
        gifData={action === "share" ? ShareGif : DeleteGif}
        yesButtonFunctionality={onYesButtonClick}
        noButtonFunctionality={onNoButtonClick}
        messageWidth={'195px'}
      />
      <ConfirmationPopup
        open={openShareConfirmationPopup}
        message={`Do you wish to share the submitted assignment with your teacher?`}
        gifData={ShareGif}
        yesButtonFunctionality={onYesButtonClickShare}
        noButtonFunctionality={onNoButtonClickShare}
        messageWidth={'290px'}
        page='assignmentShare'
      />
      <ThemeProvider theme={theme}>
        <Dialog open={openSetExpiry} classes={{ paper: 'saveQuizPaperStyle expiryPaperStyle' }}>
            <form onSubmit={handleSubmit(onSubmitExpiry)} className='popupContainer'>
              <button type="button" className="closeButton" data-testid="closeButton" onClick={handleCloseSetExpiry}>
                <img className="closeIconImage" alt="closeIcon" src={closeIcon} />
              </button>
                <div className='messageContainer titlestyle'>Set Expiration Time</div>
                <div className="quizNameContainer expiryTimeContainer">
                  <div className='expiryHourContainer'>
                      <label htmlFor="expiryTimeHours" className='messageContainer'>Hours</label>
                      <input
                        id="expiryTimeHours"
                        type="number"
                        step={1}
                        placeholder='Enter a hours'
                        className="quizName"
                        disabled={expiryLoading || setExpiryLoading}
                        {...expiryHoursRegister}
                        onChange={(e) => {
                          const num = Number(e.target.value);
                          const clamped = isNaN(num) ? 0 : Math.max(0, Math.floor(num));
                          setValue('expiryTimeHours', clamped, { shouldValidate: true });
                          trigger('expiryTimeMinutes');
                        }}
                      />
                      {errors.expiryTimeHours && (
                        <span className="error">{errors.expiryTimeHours.message}</span>
                      )}
                    </div>
                    <div className='expiryMinutesContainer'>
                      <label htmlFor="expiryTimeMinutes" className='messageContainer'>Minutes</label>
                      <input
                        id="expiryTimeMinutes"
                        type="number"
                        min={0}
                        max={59}
                        step={1}
                        placeholder='Enter a minutes'
                        className="quizName"
                        disabled={expiryLoading || setExpiryLoading}
                        {...expiryMinutesRegister}
                        onChange={(e) => {
                          const num = Number(e.target.value);
                          const clamped = isNaN(num) ? 0 : Math.max(0, Math.min(59, Math.floor(num)));
                          setValue('expiryTimeMinutes', clamped, { shouldValidate: true });
                          trigger('expiryTimeHours');
                        }}
                      />
                      {errors.expiryTimeMinutes && (
                        <span className="error">{errors.expiryTimeMinutes.message}</span>
                      )}
                    </div>
                </div>
                <div className="btnContainer">
                  <button type="submit" className='okButtonStyle' disabled={setExpiryLoading}>Submit</button>
                </div>
            </form>
        </Dialog>
      </ThemeProvider>
    </div>
  )
}

export default Assignments;
